function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1_Trash",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-435.000000, -354.000000)",
  fill: "#2E2E2E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "trash",
  transform: "translate(435.000000, 354.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14,4 L19,4 C19.5522847,4 20,4.44771525 20,5 C20,5.55228475 19.5522847,6 19,6 L18,6 L18,18 C18,19.1045695 17.1045695,20 16,20 L4,20 C2.8954305,20 2,19.1045695 2,18 L2,6 L1,6 C0.44771525,6 6.76353751e-17,5.55228475 0,5 C-6.76353751e-17,4.44771525 0.44771525,4 1,4 L6,4 L6,2 C6,0.8954305 6.8954305,2.02906125e-16 8,0 L12,0 C13.1045695,-2.02906125e-16 14,0.8954305 14,2 L14,4 Z M4,6 L4,17 C4,17.5522847 4.44771525,18 5,18 L15,18 C15.5522847,18 16,17.5522847 16,17 L16,6 L4,6 Z M8,8 C8.55228475,8 9,8.44771525 9,9 L9,15 C9,15.5522847 8.55228475,16 8,16 C7.44771525,16 7,15.5522847 7,15 L7,9 C7,8.44771525 7.44771525,8 8,8 Z M12,8 C12.5522847,8 13,8.44771525 13,9 L13,15 C13,15.5522847 12.5522847,16 12,16 C11.4477153,16 11,15.5522847 11,15 L11,9 C11,8.44771525 11.4477153,8 12,8 Z M9,2 C8.44771525,2 8,2.44771525 8,3 L8,4 L12,4 L12,3 C12,2.44771525 11.5522847,2 11,2 L9,2 Z",
  id: "Shape"
}))));

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.11a22ed4.svg";
export { ForwardRef as ReactComponent };